import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { TechnologicalTransferView, getTechnologicalTransferOptions } from '@/module/Author/TechnologicalTransfer';

export const Route = createFileRoute(
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { technologicalTransferId } = Route.useParams();
  const { data: technologicalTransfer } = useSuspenseQuery(getTechnologicalTransferOptions(technologicalTransferId));

  return <TechnologicalTransferView technologicalTransfer={technologicalTransfer} />;
}
